<template>
  <div class="carousel__main">
    <swiper class="carousel__slider" :ref="`carousel-${nth}`" :options="swiperOptions">
      <template v-for="img in imgs">
        <swiper-slide :key="img.id">
          <img class="carousel__img" :src="img.src" />
        </swiper-slide>
      </template>
    </swiper>
    <div class="carousel__caption" v-if="caption" v-html="caption"></div>
    <div class="carousel__nav">
      <div id="carousel__prev" @click="carouselSwiper.slidePrev()">PREV</div>
      <div id="carousel__pagination">{{ carouselSwiper.activeIndex + 1 + " / " + slidesLength }}</div>
      <div id="carousel__next" @click="carouselSwiper.slideNext()">NEXT</div>
    </div>
  </div>
</template>

<style scoped>
.carousel__main {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  color: #000000;
  background-color: #ffffff;
  overflow: hidden;
}

.carousel__slider {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel__img {
  width: 100%;
}

.carousel__caption {
  border-top: 1px solid #000000;
  padding: 20px;
  width: 100%;
  font-size: 12px;
}

.carousel__nav {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #000000;
  padding: 20px;
  width: 100%;
}

.carousel__nav > div {
  font-size: 12px;
  user-select: none;
}

#carousel__pagination {
  text-align: center;
}

#carousel__prev,
#carousel__next {
  cursor: pointer;
}
</style>

<script>
export default {
  title: "Carousel",
  props: {
    nth: String,
    imgs: Array,
    caption: String
  },
  data() {
    return {
      swiperOptions: {
        preloadImages: true,
        autoHeight: true,
        updateOnWindowResize: true,
        grabCursor: true
      },
      carouselSwiper: {},
      slidesLength: Number
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.carouselSwiper = this.$refs[`carousel-${this.nth}`].$swiper;
      this.slidesLength = this.carouselSwiper.slides.length;
    });
  }
};
</script>
